import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import auth from 'store/modules/auth.js';
import profile from 'store/modules/profile.js';
import accounts from 'store/modules/accounts.js';
import users from 'store/modules/users.js';
import projects from 'store/modules/projects.js';
import invoices from 'store/modules/invoices.js';
import invoiceDocuments from 'store/modules/invoice-documents.js';
import invoiceProcessors from 'store/modules/invoice-processors.js';
import bookings from 'store/modules/bookings.js';
import projectDiary from 'store/modules/project-diary.js';
import bookedTasks from 'store/modules/booked-tasks.js';
import tasks from 'store/modules/tasks.js';
import projectAreas from 'store/modules/project-areas.js';
import projectUsers from 'store/modules/project-users.js';
import assets from 'store/modules/assets.js';
import assetEvents from 'store/modules/asset-events.js';
import workers from 'store/modules/workers.js';
import workerDocuments from 'store/modules/worker-documents.js';
import workerDocumentTypes from 'store/modules/worker-document-types.js';
import workerDiary from 'store/modules/worker-diary.js';
import dataImports from 'store/modules/data-imports.js';
import dataExports from 'store/modules/data-exports.js';
import submissions from 'store/modules/submissions.js';

const state = {
}

const getters = {
}

const actions = {
}

const mutations = {
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,

  modules: {
    auth,
    profile,
    accounts,
    users,
    projects,
    invoices,
    invoiceDocuments,
    invoiceProcessors,
    bookings,
    projectDiary,
    bookedTasks,
    tasks,
    projectAreas,
    projectUsers,
    assets,
    assetEvents,
    workers,
    workerDocuments,
    workerDocumentTypes,
    workerDiary,
    dataImports,
    dataExports,
    submissions
  },
});